import { __decorate, __metadata } from "tslib";
import { AccessState } from '@core/frontend-shared';
import { AppRequestService } from '@core/frontend-shared/api';
import { GetMaintenanceSettingsRequest, MaintenanceSettingsKeys, UpdateMaintenanceSettingsRequest } from '@common/maintenance/shared';
import { isEqualDeep } from '@core/shared/utils';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { skipWhile, take } from 'rxjs/operators';
import { MaintenanceActions } from './maintenance.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "@core/frontend-shared/api";
// Interesting other concept: https://blog.nodeswat.com/automagic-reload-for-clients-after-deploy-with-angular-4-8440c9fdd96c
let MaintenanceState = /*#__PURE__*/(() => {
  let MaintenanceState = class MaintenanceState {
    static settings(state) {
      return state.settings;
    }
    static announcement(state) {
      return state.settings?.announcementText;
    }
    static maintenanceMode(state) {
      return state.settings?.maintenanceMode;
    }
    static loaded(state) {
      return state.loaded;
    }
    constructor(
    // private config:ConfigService,
    store, api) {
      this.store = store;
      this.api = api;
    }
    ngxsOnInit(ctx) {
      ctx.dispatch(new MaintenanceActions.LoadSettings());
    }
    loadSettings(ctx, action) {
      // settings must not be loaded before the admin has logged in. 
      const isAdmin = this.store.selectSnapshot(AccessState.isAdmin);
      if (!isAdmin) {
        this.store.select(AccessState.isAdmin).pipe(skipWhile(val => val === false), take(1)).subscribe(() => {
          ctx.dispatch(new MaintenanceActions.LoadSettings());
        });
        return;
      }
      this.api.sendRequest(GetMaintenanceSettingsRequest).subscribe(response => {
        const settings = response;
        const state = ctx.getState();
        if (!state.loaded || !isEqualDeep(state.settings, settings)) {
          ctx.patchState({
            settings,
            loaded: true
          });
        }
      });
      setTimeout(() => {
        ctx.dispatch(new MaintenanceActions.LoadSettings());
      }, 2 * 60 * 1000); // 2 minutes interval
    }
    updateSettings(ctx, action) {
      const settings = action.settings;
      const oldSettings = ctx.getState().settings;
      // if(settings.announcement !== oldSettings.announcement) {
      // 	// update timestamp only if announcement has changed
      // 	settings.announcementTime = new Date();
      // }
      const changedSettings = {};
      MaintenanceSettingsKeys.forEach(key => {
        if (settings[key] !== oldSettings[key]) {
          changedSettings[key] = settings[key];
        }
      });
      this.api.sendRequest(UpdateMaintenanceSettingsRequest, changedSettings).subscribe(response => {
        ctx.patchState({
          settings: response
        });
      });
    }
    static {
      this.ɵfac = function MaintenanceState_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MaintenanceState)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.AppRequestService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MaintenanceState,
        factory: MaintenanceState.ɵfac
      });
    }
  };
  __decorate([Action(MaintenanceActions.LoadSettings), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, void 0]), __metadata("design:returntype", void 0)], MaintenanceState.prototype, "loadSettings", null);
  __decorate([Action(MaintenanceActions.UpdateSettings), __metadata("design:type", Function), __metadata("design:paramtypes", [Object, void 0]), __metadata("design:returntype", void 0)], MaintenanceState.prototype, "updateSettings", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], MaintenanceState, "settings", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], MaintenanceState, "announcement", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], MaintenanceState, "maintenanceMode", null);
  __decorate([Selector(), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], MaintenanceState, "loaded", null);
  MaintenanceState = __decorate([State({
    name: 'maintenance',
    defaults: {
      settings: null,
      loaded: false
    }
  }), __metadata("design:paramtypes", [Store, AppRequestService])], MaintenanceState);
  return MaintenanceState;
})();
export { MaintenanceState };